import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { WebUrl } from "shared-web/lib/webUrl"

export function financeCharges(): WebUrl {
  return {
    pathname: `/pos/receivables/finance-charges`,
  }
}

export function financeCharge(id?: PBUUID): WebUrl {
  return {
    pathname: `/pos/receivables/finance-charges/${UUID.idString(id)}`,
  }
}
